import { Result } from 'antd'

export const ResultComponent = ({
  status,
  title,
  subTitle,
  extra,
}: {
  status: 'success' | 'error' | 'info' | 'warning' | '404' | '403' | '500'
  title: string
  subTitle: string
  extra?: any
}) => {
  return <Result status={status} title={title} subTitle={subTitle} extra={extra} />
}
